import React, {useEffect} from 'react';
import FormTextArea from "../../layout/ui/FormTextArea";
import FormSelect from "../../layout/ui/FormSelect";
import {useNotifications} from "../../../providers/NotificationsProvider";
import {useApi} from "../../../providers/ApiProvider";
import ProjectsRequests from "../../../requests/ProjectsRequests";
import ProjectAccessTokensRequests from "../../../requests/ProjectAccessTokensRequests";
import FormTextField from "../../layout/ui/FormTextField";
import ButtonWithLoading from "../../layout/ui/ButtonWithLoading";
import FormCheckbox from "../../layout/ui/FormCheckbox";
import ProjectShareAutocomplete from "../ProjectShareAutocomplete";
import ProjectSharesRequests from "../../../requests/ProjectSharesRequests";

export default function ProjectShareModalFeaturedAccountAccesses({onChange = () => {}, projectId = '', className = ''}) {
    const notificationsContext = useNotifications();
    const apiContext = useApi();
    const projectSharesRequests = new ProjectSharesRequests(apiContext.api);

    const ACCESS_LEVEL_READ = 'read';
    const ACCESS_LEVEL_EDIT = 'edit';

    const [userIdOrEmail, setUserIdOrEmail] = React.useState('');
    const [sendEmailNotification, setSendEmailNotification] = React.useState(false);
    const [accessLevel, setAccessLevel] = React.useState(ACCESS_LEVEL_READ);
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState({});


    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }


    const onSubmitLocal = (e) => {
        e.preventDefault();

        if (userIdOrEmail === '') {
            setErrors({userIdOrEmail: ['Please enter an email address.']});
            return false;
        }
        if (!accessLevel || [ACCESS_LEVEL_READ, ACCESS_LEVEL_EDIT].indexOf(accessLevel) === -1) {
            setErrors({access_level: ['Please select access level.']});
            return false;
        }
        if (/*!!sendEmailNotification && */!validateEmail(userIdOrEmail)) {
            setErrors({userIdOrEmail: ['Please enter a valid email address.']});
            return false;
        }
        setErrors({});

        let data = {
            invited_id: userIdOrEmail,
            level: accessLevel,
            project_id: projectId,
            send_email: sendEmailNotification,
        };

        setLoading(true);

        projectSharesRequests.create(data, handleCreateError).then((response) => {
            if (response) {
                notificationsContext.notify('Access granted successfully.', 'success');
                onChange();
            }
        }).finally(() => {
            setLoading(false);
        });
    }


    const handleCreateError = (error) => {
        if (error && error.message === 'User already invited') {
            notificationsContext.notify('Error - User already has access', 'error');
        } else {
            notificationsContext.notify('Error granting access.', 'error');
        }
    }


    return (
        <form className={className + ''} onSubmit={onSubmitLocal} style={{maxWidth: '600px'}}>
            <h4 className="fs-4 fw-semibold">Share with other accounts</h4>

            <div className="d-flex flex-row gap-2">
                <div style={{width: '200px'}}>
                    <FormSelect
                        label="Access Level"
                        name="access_level"
                        value={accessLevel}
                        options={[
                            {value: ACCESS_LEVEL_READ, label: 'Can View'},
                            {value: ACCESS_LEVEL_EDIT, label: 'Can Edit'},
                        ]}
                        onChange={(value) => setAccessLevel(value)}
                        groupClassName="mb-3"
                    />
                </div>

                <div className="form-group flex-grow-1">
                    <label className="form-label">E-mail</label>
                    <ProjectShareAutocomplete user={userIdOrEmail} onChange={(value) => setUserIdOrEmail(value)} />
                    {errors.userIdOrEmail && errors.userIdOrEmail.map((error, index) => (
                        <div key={index} className="text-danger">{error}</div>
                    ))}
                </div>
            </div>
            <div className="d-flex flex-row align-items-center justify-content-between w-100 gap-3">
                <FormCheckbox
                    label="Send an email notification"
                    name="send_email"
                    value={sendEmailNotification}
                    onChange={(value) => setSendEmailNotification(value)}
                />
                <ButtonWithLoading
                    className="btn btn-primary"
                    label="Grant access"
                    noOriginalIconClassName={true}
                    onClick={onSubmitLocal}
                    loading={loading}
                />
            </div>
        </form>
    );
}
